import usePriorityList from './UpdatePriorityList';

export default usePriorityList;
